// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#component-root[data-v-673302b8]{padding:10px}table[data-v-673302b8]{width:100%}.badge-container[data-v-673302b8]{display:flex;justify-content:center;align-items:center}.ticket-row[data-v-673302b8]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
